import { render, staticRenderFns } from "./RequestsMenu.vue?vue&type=template&id=71788d78&scoped=true&"
import script from "./RequestsMenu.vue?vue&type=script&lang=js&"
export * from "./RequestsMenu.vue?vue&type=script&lang=js&"
import style0 from "./RequestsMenu.vue?vue&type=style&index=0&id=71788d78&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71788d78",
  null
  
)

export default component.exports